import styles from './DefaultSelect.module.css'
import { NumberStringPairs } from '../../../interfaces/systemSettings/AccountTemplate'
import { useEffect, useState, ChangeEvent } from 'react'

interface DefaultSelectProps {
  options: NumberStringPairs
  setSelectedOption: (key: number) => void
  defaultSelectedKey?: number
  label?: string
  selectWidth?: number
  disabled?: boolean
  styleOverrides?: React.CSSProperties
}

export const DefaultSelect = ({
  options,
  label,
  defaultSelectedKey,
  setSelectedOption,
  selectWidth,
  disabled,
  styleOverrides,
}: DefaultSelectProps) => {
  const [selectedValue, setSelectedValue] = useState<string>(
    defaultSelectedKey?.toString() || ''
  )

  useEffect(() => {
    if (defaultSelectedKey !== undefined) {
      setSelectedValue(defaultSelectedKey.toString())
    }
  }, [defaultSelectedKey])

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    setSelectedValue(value)
    setSelectedOption(Number(value))
  }

  return (
    <>
      {label && <label className={styles.inputLabel}>{label}</label>}
      <select
        className={styles.defaultSelect}
        style={{ width: selectWidth, ...styleOverrides }}
        value={selectedValue}
        onChange={handleChange}
        disabled={disabled}
      >
        {Object.keys(options)?.length > 0 ? (
          Object.entries(options).map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))
        ) : (
          <option value={defaultSelectedKey?.toString() || ''}>
            Laddar...
          </option>
        )}
      </select>
    </>
  )
}
